import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, TextField, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import "../style/login.scss";

function Login({ setToken }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const isDark = theme.palette.mode === "dark";


  useEffect(() => {
    const script = document.createElement("script")
    script.src = "https://www.google.com/recaptcha/api.js?render="+process.env.REACT_APP_RECAPTCHA_KEY
    script.addEventListener("submit", handleSubmit)
    document.body.appendChild(script)
}, [])

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Récupérer le token reCAPTCHA
      const recaptchaToken = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute(process.env.REACT_APP_RECAPTCHA_KEY, { action: "login" })
            .then(token => resolve(token))
            .catch(err => reject(err));
        });
      });

      const response = await axios.post(process.env.REACT_APP_DOMAIN_URL+"/login", {
        username,
        password,
        recaptchaToken,
      });

      const { token, viewRole } = response.data;

      if (token) {
        setToken(token, username ,viewRole);
        navigate("/dashboard");
      } else {
        setError(response.data.error || "Erreur inconnue");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.error || "Erreur de connexion au serveur");
      } else {
        setError("Erreur de connexion au serveur");
      }
    }
  };

  return (
    <Container component="main" maxWidth="xs" className="logContainer">
      <div className="logContainerChild">
        <div className="logo-wrapper">
          <img src="/assets/kairos.png" alt="logo kairos" />
        </div>
        <Typography component="h1" variant="h5">
          Connexion
        </Typography>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Nom d'utilisateur"
            name="username"
            autoComplete="username"
            autoFocus
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Mot de passe"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" fullWidth variant="contained" color="primary">
            Connexion
          </Button>
        </form>
        <br/>
        <p style={{ color: isDark ? 'white' : 'black' }}>
          <a href="/passwordResetMail" style={{ color: isDark ? '#90caf9' : '#1976d2' }}>
            Mot de passe oublié ?
          </a>
        </p>
      </div>
    </Container>
  );
}

export default Login;
